import { Enum } from './Enum';

export class CalendarItemEducationTypeEnum extends Enum {
    static Irl = 'irl';
    static Online = 'online';

    static items = [{
        id: CalendarItemEducationTypeEnum.Irl,
        name: 'Очное',
    }, {
        id: CalendarItemEducationTypeEnum.Online,
        name: 'Онлайн',
    }];
}
